import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FilterChipItem } from 'src/app/shared/models/filter-chip-item';

/** Maps domain short names to pill CSS class suffixes. */
const DOMAIN_PILL_MAP: Record<string, string> = {
  HTS: 'pill-hts',
  ONC: 'pill-onc',
  GEN: 'pill-gen',
  GENMED: 'pill-gen',
  ID: 'pill-id',
  COM: 'pill-com',
  CHN: 'pill-chn',
  KOR: 'pill-kor',
};

@Component({
    selector: 'rms-filter-chip-option',
    templateUrl: './filter-chip-option.component.html',
    styleUrls: ['./filter-chip-option.component.scss'],
    standalone: false
})
export class FilterChipOptionComponent implements OnInit {

  @Input() item: FilterChipItem;
  @Output() onDelete: EventEmitter<FilterChipItem> = new EventEmitter<FilterChipItem>();

  pillClass = '';
  /**
   * Tracks whether the pointer is over the X tap zone. JS-driven (rather than CSS :hover)
   * because the X's expanded ::before tap area extends beyond the visible glyph — using CSS
   * :hover here would also fire when hovering pill text, falsely suggesting deletability.
   */
  pillXArmed = false;

  constructor() { }

  ngOnInit() {
    this.pillClass = this.computePillClass();
  }

  /** Action of click in the chip */
  public onDeleteHandler(): void {
    if (!this.item.disabled) {
      this.onDelete.emit(this.item);
    }
  }

  /** Pointer entered the X tap zone — arm the synchronized pill darken/dim treatment. */
  public onPillXEnter(): void {
    this.pillXArmed = true;
  }

  /** Pointer left the X tap zone — disarm the treatment. */
  public onPillXLeave(): void {
    this.pillXArmed = false;
  }

  /** Computes the CSS class for domain-colored pills. */
  private computePillClass(): string {
    if (this.item?.type === 'domain') {
      const name = (this.item.option?.name || '').toUpperCase();
      return DOMAIN_PILL_MAP[name] || '';
    }
    return '';
  }
}
